import { useState, useEffect } from 'react'

import config from '../config'

export const useEnvDomain = () => {
  const [domain, setDomain] = useState('')

  useEffect(() => {
    setDomain(config.domain)
  }, [])

  return domain
}
